<template>
  <div>
      <div class="width-200 d-inline-block mr-1 align-top h-auto">
        <div class="w-100 cursor-pointer" @click="detail()">
          <div class="position-relative">
            <img
              :src="data.image_url"
              class="w-100 rounded"
              :class="{'grayscale' : !data.openTime.available}"
              width="145"
              height="170"
              style="object-fit: cover;"
            />
            <template v-if="data.openTime.available">
              <!-- PROMO -->
              <span v-if="is_decrease_promo" class="bg-green py-1 px-2 radius-12 body-3-1 position-absolute text-white" style="left:10px;top:10px;">-{{Math.floor(base_price.promotion_pct)}}%</span>
  
              <!-- DELIVERY -->
              <template v-if="isDelivery">
                <p :id="`delivery-best-${data.id}`" class="bg-white py-1 px-2 rounded body-3-1 position-absolute mb-0" style="right: 10px;top: 10px;">
                  <img src="../../assets/img/icon/fast-delivery.png" width="24">
                </p>
                <b-tooltip :target="`delivery-best-${data.id}`" placement="top" title="Available for delivery">
                </b-tooltip>
              </template>
  
              <!-- VARIANT -->
              <p class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute mb-0" style="left: 10px;bottom: 10px;" v-if="is_variant">{{data.variant_list.length}} {{$pluralWord(data.variant_list.length,'variant')}}</p>
  
              <!-- CART -->
              <div v-if="qtyCart > 0" class="bg-orange py-1 px-2 radius-12 position-absolute d-flex align-items-center" style="right:10px;bottom:10px;">
                <img src="../../assets/img/icon/cart.png" width="14" class="mr-2">
                <span class="body-2 text-white">{{qtyCart}}</span>
              </div>
            </template>
            <p v-else class="bg-white py-1 px-3 radius-12 body-3-1 position-absolute mb-0 d-table m-auto" style="bottom: 10px; left: 0px; right: 0px;">Not Yet Available</p>
          </div>
          <p class="mb-0 body-15 text-truncate text-black mt-1">{{data.name}}</p>
          <p
            class="mb-0 body-2-2 text-truncate font-semibold text-light-menu text-line-through"
            v-if="is_decrease_promo"
          >{{ $formatCurrency(promotion_price) }}</p>
          <p
            class="mb-0 body-15 text-truncate font-semibold text-color-orange"
          >{{ $formatCurrency(final_price) }}</p>
        </div>
      </div>
    <!-- <menuDetail v-if="show_detail" :data="data" @done="toggleDetail" /> -->
  </div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import menuDetail from '@/components/restaurant-v2/menuDetail'
  import {mapGetters} from 'vuex'

	export default{
    components:{
      menuDetail
    },
		props: ['data'],
		data(){
			return{
				show_detail: false,
        slider_option:{
          best_menu:{
            initialIndex: 0,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: true,
            cellAlign: 'left',
            groupCells: true
          }
        }
			}
		},
		computed:{
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      isDelivery(){
        if(!this.getMerchant().use_delivery) return false;
        if(!this.is_variant) return this.data.allow_delivery;
        const isVariantHasDelivery = this.data.variant_list.some(variant => variant.allow_delivery)
        return isVariantHasDelivery;
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      product_cart_index(){
        return this.getRestaurantOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
      },
      qtyCart(){
        let data = 0
        if(this.product_cart_index != -1){
          data = this.getRestaurantOrder().cart[this.product_cart_index].qty
        }

        return data
      }
		},
		methods:{
      ...mapGetters(['getRestaurantOrder', 'getMerchant', 'getMerchantTimezone']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      detail(){
        this.$emit('detail',this.data)
      },
		}
	}
</script>
<style scoped>

.object-fit {
  object-fit: cover;
}

.width-200 {
  width: 170px !important;
  margin: 0 8px;
}

.text-light-menu {
  color: #9ba1aa;
}
</style>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuItemRestaurant.vue